export const ZEE_REQUEST = "ZEE_REQUEST";
export const ZEE_SUCCESS = "ZEE_SUCCESS";
export const ZEE_FAIL = "ZEE_FAIL";
